import { FC } from 'react';

export const PartnerContact: FC = () => {
  return <section>Contact</section>;
};
